import React from 'react';

import Checkbox from '../Checkbox';

import './category.sass';

function Category({ title, questions, onInput }) {
    return (
        <div className="category">
            <h3 className="title">{title}</h3>
            {
                questions.map(each => (
                    <Checkbox label={each.label} key={each.label} onInput={state => onInput(state, each.label)} />
                ))
            }
        </div>
    );
}

export default Category;
